import React from "react";

export default function WhoComplainSexualHarassment(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Who May Complain of Sexual Harassment? 
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-1">
            SS shall entertain complaints of sexual harassment from a woman of
            any age who alleges to have been subjected to any act of sexual
            harassment while at SS’s workplace by any employee or associate of
            SS.
          </span>
        </div>
      </div>
    </div>
  );
}
